import { YodleeQuery } from '@1bill-app/services/yodlee/yodlee.query';
import { YodleeService } from '@1bill-app/services/yodlee/yodlee.service';
import { YodleeTransaction } from '@1bill-app/services/yodlee/yodlee.types';
import { Component, OnInit } from '@angular/core';
import { Platform, PopoverController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-yodlee-transactions',
  templateUrl: './yodlee-transactions.page.html',
  styleUrls: ['./yodlee-transactions.page.scss'],
})
export class YodleeTransactionsPage implements OnInit {
  subs = new SubSink();
  public transactions$: Observable<YodleeTransaction[]> = this.yodleeQuery.transactions$;
  public loading$ = this.yodleeQuery.isLoading$;
  public isPullToRefresh: boolean;
  constructor(
    private yodleeQuery: YodleeQuery,
    private logger: NGXLogger,
    private yodleeService: YodleeService,
    private popoverController: PopoverController,
    private platform: Platform,
  ) {}

  ngOnInit() {
    this.subs.sink = this.yodleeService.getTransactions().subscribe();
  }
}
